module.exports = __webpack_public_path__ + "img/register3.56c0bb3.png";